import { render, staticRenderFns } from "./backend-report.vue?vue&type=template&id=4f1d62f4&"
import script from "./backend-report.vue?vue&type=script&lang=js&"
export * from "./backend-report.vue?vue&type=script&lang=js&"
import style0 from "./backend-report.vue?vue&type=style&index=0&id=4f1d62f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports